import cn from 'classnames';
import * as React from 'react';

import { PrivateOfficeProps } from './types';

export const PrivateOffice: React.FC<PrivateOfficeProps> = props => {
  const { link, username } = props;

  return (
    <span className="c-header__cabinet-mobile-wrap">
      <a href={link} className={cn('c-header__cabinet-mobile', 'c-header-link', 'c-header__cabinet-mobile-container')}>
        <span className={cn('c-header__cabinet-mobile-text', 'c-header__cabinet-mobile-lk')}>Личный кабинет</span>
        <span className="c-header__cabinet-mobile-name" id="adaptiveHeaderUserName">
          {username}
        </span>
      </a>
    </span>
  );
};

PrivateOffice.displayName = 'PrivateOffice';
